export {StringUtil} from './util/string-util';
export {ComprovacaoAuxilioEducacaoService} from './services/comprovacao-auxilio-educacao.service';

export {InfoPendenciasComponent} from './info-pendencias/info-pendencias.component';
export {ListaAnexoComponent} from './lista-anexo/lista-anexo.component';
